export default __webpack_public_path__ + "static/media/WhiteOrder.b59388c8.svg";